<template>
  <Layout>
    <div class="mx-auto w-full max-w-[1196px] px-4.5 lg:px-10 xl:px-0">
      <AccountHeader />

      <div>
        <slot />
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import AccountHeader from '~/components/account/Header.vue'
import Layout from '~/components/Layout.vue'
</script>
